// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__36yNN","detailsBorder":"styles_detailsBorder__1djsg"};